import React from 'react';

import { ViewTitle } from 'admin-on-rest';

class Games extends React.Component {
  iframe = 'https://games.pinchos.se';

  render() {
    return (
      <div style={{ height: '100%', background: 'white' }}>
        <ViewTitle style={{ textAlign: 'center' }} title={null} />
        <small style={{ display: 'block', padding: '0 16px' }}>Ser ni inte er restaurang nedan, se till att ni använder senaste versionen av boknings-admin (i skrivande stund, 1.10.3)</small>
        <br />
        <small style={{ display: 'block', padding: '0 16px' }}>If you cannot see your restaurant below, make sure youre using the latest version of booking-admin (latest as of writing, 1.10.3)</small>
        <iframe className="games-iframe" title="Games" src={this.iframe} />
      </div>
    );
  }
}

export default Games;
